module.exports = __webpack_public_path__ + "img/东光塑料.f035a8b0.jpg";